<div class="page-container product-shelf-container container">
  @if (turnOnProductShelfBanner && productShelfBannerMessage) {
    <div class="advertisement-banner">
      {{ productShelfBannerMessage }}
    </div>
  }
  <app-utility-toolbar />
  <h1 class="header col-12"
    >Product Shelf
    <button
      *hasPermission="'AnnuityShelfChatbot'"
      class="pull-right"
      matButton="elevated"
      color="primary"
      (click)="triggerChatOpen(true)"
      ><mat-icon>auto_awesome</mat-icon>Ask about products</button
    ></h1
  >
  @if (gridView) {
    @if (!hideGrid) {
      <div class="mb-3 grid-view-row">
        <h5 class="w-100">Grid View:</h5>
        <mat-button-toggle-group
          [value]="gridView"
          (change)="changeView($event)"
        >
          <mat-button-toggle value="product">Product</mat-button-toggle>
          <mat-button-toggle value="income">Income Riders</mat-button-toggle>
          <mat-button-toggle value="death"
            >Death Benefit Riders</mat-button-toggle
          >
          @if (rights && rights.includes('AnnuityGrid')) {
            <mat-button-toggle value="fa">FA Rates</mat-button-toggle>
          }
          @if (rights && rights.includes('FIAGrid')) {
            <mat-button-toggle value="fia">FIA Rates</mat-button-toggle>
          }
          @if (rights && rights.includes('ShowVIAFunds')) {
            <mat-button-toggle value="rila">RILA Rates</mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    }

    @if (!rateViews.includes(gridView)) {
      @if (!loading && !hideGrid) {
        <app-grid-filters
          class="col-12"
          [filters]="externalFilters"
          [reset]="resetFilters"
          [preexistingFilters]="filter"
          [gridName]="gridView"
          [showFilterManager]="false"
          (filtersUpdated)="updateFilters($event)"
          (clearSingleFilter)="clearSingleFilter($event)"
        />
      }
      @if (!hideGrid) {
        <div *hasPermission="'UIExplanations'" class="all-types-notification">
          @if (!showFilterMessage) {
            <span
              class="default-types"
              [ngClass]="{ 'roll-in': !showFilterMessage }"
            >
              All annuity types are visible by default.
            </span>
          }
          <span
            class="click-information"
            [ngClass]="{ 'roll-in': showFilterMessage }"
          >
            Click the <mat-icon class="clear-indicator">close</mat-icon> to
            filter by all annuity types
          </span>
        </div>
      }
      @if (!hideGrid) {
        <div class="grid-actions mx-1">
          <div>
            <button
              type="button"
              mat-button
              color="primary"
              class="me-0 ms-2"
              [disabled]="compareList.length < 2"
              (click)="compare()"
            >
              <mat-icon class="me-2">compare_arrows</mat-icon>Compare Products
            </button>
            @if (gridView === 'income') {
              <button
                type="button"
                mat-button
                color="primary"
                class="me-0 ms-2"
                (click)="calculateIncome()"
              >
                <mat-icon class="me-2">payments</mat-icon
                >{{ incomeCalcButtonLabel }}
              </button>
            }
          </div>
          <div>
            @if (
              (gridView === 'product' ||
                gridView === 'income' ||
                gridView === 'death') &&
              managerUnitCount > 0
            ) {
              <button
                type="button"
                mat-button
                color="primary"
                class="me-0 ms-2"
                (click)="downloadExcel(productGrid)"
              >
                <mat-icon class="me-2">cloud_download</mat-icon>Download Excel
                File
              </button>
            }
            <app-grid-column-filter
              #gridColumnFilter
              [columns]="gridColumns"
              (columnsUpdated)="externalColumnsUpdated($event)"
            />
            <button
              type="button"
              mat-button
              color="primary"
              class="ms-auto me-0"
              (click)="reset(false)"
            >
              <mat-icon class="me-2">replay</mat-icon>Reset
            </button>
          </div>
        </div>
      }

      @if (!hideGrid) {
        <kendo-grid
          #productGrid="kendoGrid"
          class="col-12"
          [kendoGridBinding]="gridData.data"
          [skip]="state.skip"
          [pageSize]="state.take"
          [pageable]="true"
          [resizable]="true"
          [sortable]="{ allowUnsort: true, mode: 'multiple' }"
          [sort]="state.sort"
          [filterable]="'menu'"
          [columnMenu]="{ columnChooser: false }"
          [filter]="state.filter"
          [state]="state"
          [height]="gridHeight()"
          [navigable]="true"
          (filterChange)="filterChange($event)"
          (dataStateChange)="dataStateChange($event)"
        >
          <kendo-grid-column title="Actions" [width]="150">
            <ng-template let-dataItem kendoGridCellTemplate>
              <div class="action-buttons-container">
                @if (rights.includes('AnnuityFactsSheet')) {
                  <button
                    type="button"
                    mat-icon-button
                    class="fs-button"
                    color="primary"
                    matTooltip="Download Factsheet"
                    kendoGridFocusable
                    [disabled]="
                      dataItem.annuityType &&
                      (dataItem.annuityType.toLowerCase() === 'spia' ||
                        dataItem.annuityType.toLowerCase() === 'dia')
                    "
                    (click)="dlFactsheet(dataItem)"
                  >
                    <mat-icon>insert_drive_file</mat-icon>
                  </button>
                }
                @if (!hideLaunchToAnnuityBtn) {
                  <button
                    type="button"
                    mat-icon-button
                    class="fs-button"
                    color="primary"
                    matTooltip="Create New Case for This Annuity"
                    kendoGridFocusable
                    (click)="createNewCase(dataItem, true)"
                  >
                    <mat-icon>open_in_new</mat-icon>
                  </button>
                }
                @if (showHyposAndBrochuresBtn && dataItem['Link']) {
                  <button
                    type="button"
                    mat-icon-button
                    class="fs-button"
                    color="primary"
                    matTooltip="Carrier Hypotheticals and Client Brochures"
                    kendoGridFocusable
                    (click)="launchExternalLink(dataItem['Link'])"
                  >
                    <mat-icon>grading</mat-icon>
                  </button>
                }
                <mat-checkbox
                  matTooltip="Compare Annuity"
                  kendoGridFocusable
                  [checked]="
                    compareChecked[
                      dataItem.riderCode
                        ? dataItem.riderCode
                        : dataItem.uniqueCode
                    ]
                  "
                  (change)="compareListUpdate($event, dataItem)"
                />
              </div>
            </ng-template>
          </kendo-grid-column>
          @for (column of gridData.headers; track column) {
            <kendo-grid-column
              [field]="column.DataField"
              [hidden]="isHidden(column.DataField)"
              [title]="column.Label"
              [sortable]="column.Sort"
              [filterable]="column.Filter"
              [groupable]="column.Group"
              [media]="column.RespVis"
              [filter]="column.DataType"
              [headerClass]="columnStyleCheck(column.DataField)"
              [class]="columnStyleCheck(column.DataField)"
              [width]="column.Width ? column.Width : 150"
              [sticky]="column.Sticky"
            >
              @if (column.Sort || column.Filter) {
                <ng-template let-service="service" kendoGridColumnMenuTemplate>
                  @if (column.Sort) {
                    <kendo-grid-columnmenu-sort
                      [column]="column"
                      [service]="service"
                    >
                      <kendo-grid-messages
                        [sortAscending]="getFilterMenuText(column.Type, 'asc')"
                        [sortDescending]="
                          getFilterMenuText(column.Type, 'desc')
                        "
                      />
                    </kendo-grid-columnmenu-sort>
                  }
                  @if (column.Filter) {
                    <kendo-grid-columnmenu-filter
                      [column]="column"
                      [service]="service"
                    >
                      <ng-template
                        let-filter="filter"
                        let-filterService="filterService"
                        kendoGridFilterMenuTemplate
                      >
                        <kendo-multiselect
                          style="width: 99%"
                          textField="display"
                          valueField="value"
                          placeholder="Filter By..."
                          [data]="filterData[column.DataField]"
                          [valuePrimitive]="true"
                          [value]="filter | filterValues"
                          [fillMode]="'outline'"
                          [filterable]="true"
                          (valueChange)="
                            filterValueChange(
                              $event,
                              column.DataField,
                              filterService
                            )
                          "
                          (filterChange)="
                            onFilterChange($event, column.DataField)
                          "
                        />
                      </ng-template>
                    </kendo-grid-columnmenu-filter>
                  }
                </ng-template>
              }
              @if (column.Type === 'integer') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | number: '1.0-0' }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | number: '1.0-0' }}
                </ng-template>
              }
              @if (column.Type === 'commaSeparator') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | number: '1.0-2' }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | number: '1.0-2' }}
                </ng-template>
              }
              @if (column.Type === 'perc') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | percent }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | percent }}
                </ng-template>
              }
              @if (column.Type === 'perc2') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | percent: '1.2' }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | percent: '1.2' }}
                </ng-template>
              }
              @if (column.Type === 'curr') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ dataItem[column.DataField] | currency }}
                </ng-template>
                <ng-template
                  let-group
                  let-field="field"
                  let-value="value"
                  kendoGridGroupHeaderTemplate
                >
                  {{ value | currency }}
                </ng-template>
              }
              @if (column.DataField === 'notes') {
                <ng-template let-dataItem kendoGridCellTemplate>
                  <span [innerHtml]="dataItem[column.DataField]"></span>
                </ng-template>
              }
              @if (column.Validation) {
                <ng-template let-dataItem kendoGridCellTemplate>
                  {{ findValue(dataItem[column.DataField], column.Validation) }}
                </ng-template>
              }
            </kendo-grid-column>
          }
          @if (gridData['subHead']) {
            <ng-template let-dataItem kendoGridDetailTemplate>
              <!--  -->
              <!-- Have to make specific tabs to force order and not have multiple rate summary sections show up and the ability to show messages for empty datasets -->
              <!-- Good code is commented out below... -->
              <!--  -->
              @if (gridView === 'product') {
                <mat-tab-group mat-stretch-tabs>
                  @for (
                    tab of gridData.subHead | keyvalue: originalOrder;
                    track tab
                  ) {
                    @if (tab.key === 'riders') {
                      <mat-tab [label]="'Income Riders'">
                        <app-product-detail-tab
                          [dataItem]="dataItem"
                          [tab]="tab"
                          [noResultsType]="'riders'"
                        />
                      </mat-tab>
                    }
                    @if (tab.key === 'deathRiders') {
                      <mat-tab [label]="'Death Benefit Riders'">
                        <app-product-detail-tab
                          [dataItem]="dataItem"
                          [tab]="tab"
                          [noResultsType]="'death benefit riders'"
                        />
                      </mat-tab>
                    }
                    @if (
                      (tab.key === 'fiaRates' &&
                        dataItem.annuityType.toLowerCase() === 'fia') ||
                      (tab.key === 'faRates' &&
                        dataItem.annuityType.toLowerCase() === 'fa') ||
                      (tab.key === 'viaRates' &&
                        dataItem.annuityType.toLowerCase() === 'rila')
                    ) {
                      <mat-tab [label]="'Rates Summary'">
                        <app-product-detail-tab
                          [dataItem]="dataItem"
                          [tab]="tab"
                          [noResultsType]="'rates'"
                        />
                      </mat-tab>
                    }
                    @if (
                      tab.key === 'funds' &&
                      dataItem[tab.key] &&
                      dataItem[tab.key].length > 0
                    ) {
                      <mat-tab [label]="'Investment Options'">
                        <app-product-detail-tab
                          [dataItem]="dataItem"
                          [tab]="tab"
                        />
                      </mat-tab>
                    }
                  }
                  @if (showNotes(dataItem.notes)) {
                    <mat-tab label="Notes">
                      @for (
                        note of dataItem.notes | keyvalue;
                        track note;
                        let idx = $index
                      ) {
                        @if (note.key === 'notes' && note.value.length > 0) {
                          <h5 [ngClass]="{ 'mt-3': idx === 0 }"> Notes: </h5>
                        }
                        @if (
                          note.key === 'firmNotes' && note.value.length > 0
                        ) {
                          <h5 [ngClass]="{ 'mt-3': idx === 0 }">
                            Firm Notes:
                          </h5>
                        }
                        @if (note.value.length > 0) {
                          <p [innerHTML]="note.value"></p>
                        }
                      }
                    </mat-tab>
                  }
                </mat-tab-group>
              } @else {
                <table class="w-100 detail-table">
                  @for (
                    headers of gridData.subHead | keyvalue: originalOrder;
                    track headers
                  ) {
                    <thead>
                      @for (hdr of headers.value; track hdr) {
                        <th>{{ hdr.Label }}</th>
                      }
                    </thead>
                  }
                  <tbody>
                    @for (
                      column of gridData.subHead | keyvalue: originalOrder;
                      track column
                    ) {
                      <tr>
                        @for (
                          clm of column.value | keyvalue: originalOrder;
                          track clm
                        ) {
                          <td
                            [innerHTML]="
                              dataItem.subInfo[0][clm.value.DataField]
                            "
                          ></td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </ng-template>
          }
          <ng-template
            let-totalPages="totalPages"
            let-currentPage="currentPage"
            kendoPagerTemplate
          >
            <kendo-pager-prev-buttons />
            <kendo-pager-numeric-buttons />
            <kendo-pager-next-buttons />
            <kendo-pager-input />
            <kendo-pager-info />
            <kendo-pager-page-sizes [pageSizes]="pageSizeOptions" />
          </ng-template>
          <kendo-grid-excel
            fileName="RightBridge-ProductShelf.xlsx"
            [fetchData]="excelData"
          />
        </kendo-grid>
      }
    }

    @if (gridView === 'fia') {
      <app-fia />
    }

    @if (gridView === 'fa') {
      <app-fa />
    }

    @if (gridView === 'rila') {
      <app-via />
    }
  }
</div>
<ngx-loading [show]="loading" />
<app-chat-panel
  [panelOpen]="chatOpen"
  (emitPanelOpen)="triggerChatOpen($event)"
/>
